import * as React from "react";
import { Market, Selection } from "../../../../../../contracts";
import { BetBtnMultiview } from "../../../BetBtnMultiview";

export const renderBetButtonsMultiview = (market: Market, betButtonHandler: (market: Market, selection: Selection) => void, componentPrefix: string) => {
    return (
        <div key={`${componentPrefix}__${market.id}`} className={`rj-ev-list__ev-card__section rj-ev-list__ev-card__section--${market.template}`} data-uat={`div-ev-list-ev-card-${componentPrefix}-section`}>
            {market.selections && market.selections.map(
                (s, index) => {
                    let betslipModifier = s.isSelectionInBetslip ? "rj-ev-list__bet-btn--chosen" : "";
                    return (
                        <BetBtnMultiview
                            key={`${componentPrefix}__bet-btn__${market.id || "m"}-${s && s.id || "s"}-${index}`}
                            isDisabled={s.isDisabled}
                            classNames={`${betslipModifier}`}
                            handler={() => betButtonHandler(market as Market, s as Selection)}
                            odd={s.odds}
                            trueOdds={s.trueOdds}
                            point={s.odds ? "" : s.pointsText}
                        />
                    )
                }
            )}
        </div>
    )
}